const getCSRFToken = () => {
  const token = document.querySelector('meta[name="csrf-token"]');
  return token && token.getAttribute('content');
};

export const headersWithCSRF = {
  'Content-Type': 'application/json',
  'X-CSRF-Token': getCSRFToken(),
};
